import type { ReactElement } from 'react';

import { Card, CardContent, CardFooter } from '../..';
import { Skeleton } from '../../skeleton';

export const PodSkeleton = (): ReactElement => {
  return (
    <Card>
      <div className="co-h-300px">
        <Skeleton variant="rectangular" />
      </div>
      <CardContent>
        <div className="co-flex co-box co-flex-col co-gap-16px co-relative co-overflow-hidden">
          <div className="co-h-32px">
            <Skeleton variant="rectangular" />
          </div>
          <div className="co-flex co-flex-col co-gap-4px co-min-h-48px co-h-48px">
            <Skeleton variant="rectangular" />
          </div>
          <div className="co-h-56px">
            <div className="co-h-full co-flex co-gap-4px">
              <Skeleton variant="rectangular" delay={0.2} />
              <Skeleton variant="rectangular" delay={0.4} />
              <Skeleton variant="rectangular" delay={0.6} />
            </div>
          </div>
          <div className="co-h-32px co-flex co-items-center">
            <div className="co-h-full co-w-full co-flex">
              <Skeleton variant="rectangular" />
            </div>
          </div>
        </div>
      </CardContent>
      <CardFooter>
        <div className="co-h-40px">
          <Skeleton variant="rectangular" />
        </div>
      </CardFooter>
    </Card>
  );
};
